import { useCentralizedMe } from '@crehana/auth';
import { Avatar } from '@crehana/compass.ui/v3/avatar';

export const RequesterBanner = () => {
  const { me } = useCentralizedMe();

  return (
    <div className="tw-flex tw-items-center tw-cds-gap-3 tw-cds-bg-subtle-01 tw-border-b tw-border-solid tw-cds-border-divider tw-cds-p-5">
      <Avatar src={me.user.avatarUrl} alt={me.user.fullName} size="md" />
      <div className="tw-flex tw-flex-col">
        <span className="tw-cds-font-subtitle-02 tw-cds-text-primary">
          {me.user.fullName}
        </span>
        <span className="tw-cds-font-body-02 tw-cds-text-secondary">
          {me.position?.name ?? ''}
        </span>
      </div>
    </div>
  );
};
